import { Component, OnDestroy, OnInit } from '@angular/core';
import { ClientApiService } from '@anduin/api';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-clients',
  templateUrl: './clients.component.html',
  styleUrls: ['./clients.component.scss'],
  standalone: false,
})
export class ClientsComponent implements OnInit, OnDestroy {
  private _unsubscribe$: Subject<void> = new Subject<void>();

  /** string to search tables rows by */
  searchValue = '';

  clientCount: number;

  constructor(private clientsApiService: ClientApiService) {}

  ngOnInit(): void {
    this.clientsApiService
      .getClientCount()
      .pipe(takeUntil(this._unsubscribe$))
      .subscribe((count) => {
        this.clientCount = count;
      });
  }

  ngOnDestroy(): void {
    this._unsubscribe$.next();
    this._unsubscribe$.complete();
  }

  /**
   * Apply search filter to table
   * @param event
   */
  applySearch(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.searchValue = filterValue.trim().toLowerCase();
  }
}
